export default __webpack_public_path__ + "static/media/weekly-calender.e72225f7.svg";